import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EmptyStateModule } from '@michelin/theme';
import { NgxCsvParser } from 'ngx-csv-parser';
import { ApplicationService } from '../application/application.service';
import { ImportFileComponent } from '../application/import-file/import-file.component';
import { ApplicationsService } from '../applications/applications.service';
import { Applications } from '../interfaces/application';
import { ImportFileCsv } from '../interfaces/importFileCsv';

@Component({
  selector: 'mic-app-homecvm',
  templateUrl: './homecvm.component.html',
  styleUrls: ['./homecvm.component.scss'],
  imports: [ImportFileComponent, EmptyStateModule]
})
export class HomecvmComponent implements OnInit {
  private readonly ngxCsvParser = inject(NgxCsvParser);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly appService = inject(ApplicationService);
  private readonly applicationsService = inject(ApplicationsService);
  private readonly cdr = inject(ChangeDetectorRef);

  application: Applications;
  importFileCsvs: ImportFileCsv[] = [];
  csvRecords: any;
  header = true;

  selectedSimpleFileInput: any;

  @ViewChild('fileImportInput') fileImportInput: any;
  ngOnInit(): void {
    // console.log('the name of the application that i will use ', this.route.snapshot.params['name']);
    this.route.params.subscribe((params: Params) => {
      if (params['name'] !== 'HBI') {
        this.appService.getApplicationByName(this.route.snapshot.params['name']).subscribe((response) => {
          this.applicationsService.myObject = response;
          this.importFileCsvs = response.importFileCsvs;
          this.cdr.detectChanges();
        });
      } else {
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    });
  }

  selectSimpleFileInput($event: any) {
    this.selectedSimpleFileInput = $event.target.files;
    this.header = (this.header as unknown as string) === 'true' || this.header === true;
    this.ngxCsvParser
      .parse(this.selectedSimpleFileInput[0], { header: true, delimiter: ',' })
      .pipe()
      .subscribe({
        next: (result): void => {
          this.csvRecords = result;
        },
        error: (): void => {}
      });
  }
}
